import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconAuction = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.2594 4.42882C12.2999 3.85706 13.5594 3.85706 14.5988 4.42882C15.0368 4.66794 15.4286 5.06095 15.9353 5.56761L16.1247 5.75702C16.6313 6.26368 17.0231 6.65431 17.2634 7.09231C17.8339 8.13285 17.8339 9.39238 17.2634 10.4328C17.0231 10.8708 16.6313 11.2615 16.1247 11.7681L14.6154 13.2762L19.723 18.3841C20.0923 18.7535 20.0923 19.3536 19.723 19.723C19.3525 20.0923 18.7535 20.0923 18.383 19.723L13.2763 14.616L11.7683 16.1242C11.2616 16.6308 10.8699 17.0239 10.4319 17.263C9.39255 17.8347 8.1331 17.8347 7.09246 17.263C6.65449 17.0238 6.26267 16.6308 5.75603 16.1242L5.56782 15.9348C5.06 15.4281 4.66818 15.0375 4.42791 14.5995C3.85736 13.5589 3.85736 12.2994 4.42791 11.259C4.6682 10.821 5.06 10.4303 5.56782 9.92369L9.92268 5.56737C10.4293 5.06071 10.8211 4.66768 11.2591 4.42858L11.2594 4.42882ZM13.6884 6.08849C13.2149 5.82924 12.6432 5.82924 12.1697 6.08849C12.0028 6.18083 11.8146 6.35484 11.1683 7.00118L7.00161 11.1681C6.35531 11.8156 6.1813 12.0027 6.08897 12.1708C5.82974 12.6431 5.82974 13.216 6.08897 13.6884C6.1813 13.8565 6.35531 14.0435 7.00161 14.691C7.64791 15.3374 7.83613 15.5114 8.00304 15.6037C8.47652 15.863 9.04825 15.863 9.52174 15.6037C9.68982 15.5114 9.87686 15.3374 10.5232 14.691L14.6898 10.5241C15.3373 9.87659 15.5113 9.68955 15.6025 9.52145C15.8617 9.04912 15.8617 8.47618 15.6025 8.00385C15.5113 7.83575 15.3373 7.6487 14.6898 7.00118C14.0435 6.35484 13.8565 6.18083 13.6884 6.08849Z"
        />
      </svg>
    );
  }
);
